
export default {
    components: {},
    props: {
        to: {
            type: String,
            default: 'body'
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '弹窗标题'
        },
        clickMaskClose: {
            type: Boolean,
            default: true
        },
        showMask: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '400px'
        }
    },
    data () {
        return {
            originalParent: null
        }
    },
    watch: {
        visible (newVal) {
            if (newVal) {
                this.moveToPortal()
            }
            // 移除时不在这里调用 moveBack，而是在过渡动画完成后调用
        }
    },
    mounted () {
        if (this.visible) {
            this.moveToPortal()
        }
    },
    beforeDestroy () {
        this.moveBack()
    },
    methods: {
        moveToPortal () {
            this.$nextTick(() => {
                const parentDom = document.querySelector(this.to)
                const popup = this.$refs.popup

                if (parentDom && popup) {
                    // 记录原始父元素
                    this.originalParent = popup.parentNode
                    // 移动到指定容器中
                    parentDom.appendChild(popup)
                }
            })
        },
        moveBack () {
            const popup = this.$refs.popup
            if (popup && this.originalParent) {
                // 移回原位置
                this.originalParent.appendChild(popup)
            }
        },
        close () {
            this.$emit('close')
            this.$emit('update:visible', false)
        },
        handleOverlayClick () {
            if (this.clickMaskClose) {
                this.close()
            }
        }
    }
}
